import { render, staticRenderFns } from "./DetailsRow.vue?vue&type=template&id=3205c08a&scoped=true&"
import script from "./DetailsRow.vue?vue&type=script&lang=ts&"
export * from "./DetailsRow.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsRow.vue?vue&type=style&index=0&id=3205c08a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205c08a",
  null
  
)

export default component.exports